var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.00001L20 2C21.1046 2 22 2.89543 22 4V17C22 19.7614 19.7614 22 17 22H7C4.23858 22 2 19.7614 2 17V4.00001C2 2.89544 2.89543 2.00001 4 2.00001ZM8.75 7.00001V5.00001C8.75 4.58579 8.41421 4.25001 8 4.25001C7.58579 4.25001 7.25 4.58579 7.25 5.00001V7.00001C7.25 9.62336 9.37665 11.75 12 11.75C14.6234 11.75 16.75 9.62336 16.75 7.00001V5.00001C16.75 4.58579 16.4142 4.25001 16 4.25001C15.5858 4.25001 15.25 4.58579 15.25 5.00001V7.00001C15.25 8.79493 13.7949 10.25 12 10.25C10.2051 10.25 8.75 8.79493 8.75 7.00001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag13);
export default __webpack_public_path__ + "static/media/shopping-bag-13.4ff6a451e3e42b7208b1852be3dfc09e.svg";
export { ForwardRef as ReactComponent };